module.exports = __webpack_public_path__ + "media/images/icons/my-events-e0b085e7c5eb1dada496fc8562663175.svg";